import { render, staticRenderFns } from "./dependentCustomers.vue?vue&type=template&id=235859e7"
import script from "./dependentCustomers.vue?vue&type=script&lang=ts"
export * from "./dependentCustomers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports